import { OrgRecordingList } from '@/modules/manager/components/org/recording-session/list';
import { withMotion } from '../hoc/with-motion';

const AnimatedPage = withMotion(OrgRecordingList);

export const roles: string[] = [];
export const path = '/manager/:orgId/recording';
export const element = <AnimatedPage />